import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AddDetailsAndId from "../../../components/Landlord/created-tenants/AddDetailsAndId";
import AddDocumentsPending from "../../../components/Landlord/created-tenants/AddDocumentsPending";
import AddForm from "../../../components/Landlord/created-tenants/AddForm";
import LandLordContext from "../../../context/landlord/LandLordContext";
import AuthContext from "../../../context/auth/AuthContext";
import { getIncomeForEffortRate, haveValue } from "../../../helper/common";
import ProfileWrapper from "../../../components/Landlord/created-tenants/ProfileWrapper";
import useTranslator from "../../../hooks/useTranslator";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";

const ViewTenantDetails = () => {
  const navigate = useNavigate();
  const { _t } = useTranslator();
  const { id } = useParams();
  const { fetchingCreatedTenant, updateCreatedTenant } =
    useContext(LandLordContext);
  const { setLoading } = useContext(AuthContext);
  const [currentScreen, setCurrentScreen] = useState("main");
  const [user, setUser] = useState(null);
  const [showEffortModal, setShowEffortModal] = useState(false);
  const [haveEffortIncome, setHaveEffortIncome] = useState(false);
  const [effortRateForm, setEfforRateForm] = useState({
    current_annual_income: null,
    rent: null,
  });

  useEffect(() => {
    if (id == "create") {
      setCurrentScreen("form");
    } else {
      setLoading(true);
      fetchingCreatedTenant(id)
        .then((res) => {
          setLoading(false);
          setUser(res.data);
        })
        .catch((err) => {
          setLoading(false);
          console.log(err, "Error inside fetchingCreatedTenant");
        });
    }
  }, []);

  const handleGenerateReport = async () => {
    // if (haveValue(user?.rent)) {
    //   navigate(`/generatedReport/${id}?llCreated=true`);
    // } else {
    const temp = await getIncomeForEffortRate(user);
    console.log(temp, "checkTempValhere");
    if (!haveValue(temp)) {
      setHaveEffortIncome(false);
    } else {
      setHaveEffortIncome(true);
    }
    setShowEffortModal(true);
    // }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEfforRateForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmitForm = () => {
    if (
      (haveEffortIncome || haveValue(effortRateForm?.current_annual_income)) &&
      haveValue(effortRateForm?.rent)
    ) {
      let temp_data = {
        rent: effortRateForm?.rent,
        id: id,
      };
      if (haveValue(effortRateForm?.current_annual_income)) {
        temp_data.current_annual_income = effortRateForm?.current_annual_income;
      }
      updateCreatedTenant(temp_data)
        .then((res) => {
          navigate(
            `/generatedReport/${id}?llCreated=true&rent=${effortRateForm?.rent}`
          );
        })
        .catch((err) => {
          console.log("Error", err);
        });
    } else {
      toast.error(_t("allFieldsAreMandatory"));
    }
  };

  return (
    <>
      {/* <h1>ViewTenantDetails page {id}</h1> */}

      {currentScreen == "main" && (
        <>
          {haveValue(user) && (
            <div className="generate-btn">
              <a href={undefined} onClick={(e) => navigate("/created-tenant")}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="18"
                  viewBox="0 0 10 18"
                  fill="none"
                >
                  <path
                    d="M9 1L1 9L9 17"
                    stroke="#121212"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>
              <h2 className="profile-person-name">{`${user?.fname ?? ""} ${
                user?.lname ?? ""
              }`}</h2>
              <button className="btn btngreen" onClick={handleGenerateReport}>
                {_t("generateReport")}
              </button>
            </div>
          )}
          {haveValue(user) ? (
            <ProfileWrapper user={user} setUser={setUser} />
          ) : (
            <AddDetailsAndId setCurrentScreen={setCurrentScreen} />
          )}

          <AddDocumentsPending id={id} user={user} setUser={setUser} />
        </>
      )}

      {currentScreen == "form" && <AddForm />}

      <Modal
        show={showEffortModal}
        onHide={(e) => setShowEffortModal(false)}
        centered
        className="newmodalui asguarantor modal-xl add-landlord-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h4>
              {_t(
                "beforeGeneratingReportProvide",
                "On LL side while generating report for created TT"
              )}
            </h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            {haveEffortIncome ? null : (
              <>
                <label htmlFor="" className="mb-2">
                  {_t("declaredTenantGrossIncome")}
                </label>
                <input
                  type="number"
                  onChange={handleInputChange}
                  name="current_annual_income"
                  onKeyDown={(e) => {
                    if ([".", ",", "e", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  value={effortRateForm?.current_annual_income ?? 0}
                  className="form-control special-gap"
                />
              </>
            )}
            <label htmlFor="" className="mb-2">
              {_t("rent")}
            </label>
            <input
              type="number"
              onChange={handleInputChange}
              name="rent"
              value={effortRateForm?.rent ?? 0}
              className="form-control special-gap"
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btngreen w-100" onClick={handleSubmitForm}>
            {_t("submit")}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ViewTenantDetails;
